module.exports = __webpack_public_path__ + "static/media/error-icon.5831796d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/error-icon.svg
// module id = 1020
// module chunks = 0